import { ForgotPasswordSchema } from '@next-pontos/validations';
import { useFormik } from "formik";
import { enqueueSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import { Button, Grid, Input, Loader } from "../../components";
import { useAxios } from "../../hooks";

export function ForgotPassword() {
    const [forgotPassword, sendPasswordRecoveryLink] = useAxios({
        url: '/auth/forgot-password',
        method: 'POST',
    }, {
        manual: true
    })

    const formik = useFormik({
        initialValues: {
            login: '',
        },
        onSubmit: async (values, { resetForm }) => {
            sendPasswordRecoveryLink({
                data: values
            })

            enqueueSnackbar('Link de recuperação enviado!', { variant: 'success' })
            resetForm()
        },
        validationSchema: ForgotPasswordSchema,
        validateOnMount: true
    })

    return (
        <Grid container className="min-h-screen items-center justify-center bg-[#ebebeb] bg-cover bg-center bg-no-repeat" style={{ backgroundImage: 'url(/background.png)' }}>
            {forgotPassword.loading ? (
                <Loader />
            ) : (
                <Grid item xs={12} sm={4}>
                    <form onSubmit={formik.handleSubmit}>
                        <Grid container className="p-2 gap-4 justify-center text-center">
                            <img src="/logo.png" alt="Logo" className="w-full max-w-[300px] h-auto" />
                            <Grid item xs={12} sm={12}>
                                <Input
                                    label="Email ou CPF"
                                    name="login"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.login}
                                    helperText={formik.touched.login && formik.errors.login}
                                    error={!!formik.touched.login && !!formik.errors.login}
                                />
                            </Grid>

                            <Grid item className="mt-2" xs={12}>
                                <Button disabled={!formik.isValid} type="submit">Enviar</Button>
                            </Grid>
                        </Grid>
                    </form>
                </Grid>
            )}
        </Grid>
    )
}